<template>
    <div class="flag-record" v-if="problemList.length > 0">
        <div v-for="problem in problemList" :key="problem.problem_id" class="flag-list">
            <el-popover
                placement="bottom"
                width="300">
                <div class="flag-content">
                    <div class="comment">{{ problem.comment }}</div>
                    <span class="comment-detail">
                        Comment added by {{ problem.modified_name ? problem.modified_name : getUploader(problem.modified_by) }} on {{ formatDateTime(problem.modified_time) }}
                    </span>
                    <LoadingButton v-if="!problem.resolved_time" class="resolve-button" 
                        @click="markClosed(problem.problem_id, problem.question_id)" 
                        type="primary"
                        :small="true"
                        :loading="loading">
                        Mark as Resolved
                    </LoadingButton>
                    <div class="resolved-status" v-else>
                        <el-button class="resolve-button resolved">
                            <img :src="require('@/module/outcome/image/flag-green.svg')">
                            RESOLVED
                        </el-button>
                        <span class="resolve-datetime">
                            <div>
                                {{ getUploader(problem.resolved_by) }}
                            </div>
                            <div>
                                {{ formatDateTime(problem.resolved_time) }} 
                            </div>
                        </span>
                    </div>
                    
                </div>
                <el-button slot="reference" :class="['flag-button', { resolved: problem.resolved_time}]" 
                    size="mini" round>
                    <img :src="problem.resolved_time ? require('@/module/outcome/image/flag-green.svg') : require('@/module/outcome/image/flag.svg')" >
                     {{ problem.resolved_time ? 'RESOLVED' : 'FLAGGED' }} 
                </el-button>
            </el-popover>
        </div>
    </div>
</template>

<script>
import formatDateTime from '@/module/util/format-date-time'

import LoadingButton from '@/module/component/LoadingButton.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'flag-record',

    props: {
        event: {
            type: Object
        },
        question: {
            type: Object
        },
        patient: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loading: false
        }
        
    },

    methods: {
        ...mapActions('outcome', ['resolveFlagging']),
        formatDateTime,
        markClosed(problem_id, question_id) {
            this.loading = true
            const query = {
                patient: this.patient.id,
                survey: this.event.id,
                type: 'resolution',
                questionnaire: this.event.event,
                question_id,
                problem_id,
                auth: this.getUser.id
            }
            this.loading = true
            this.resolveFlagging(query)
                .then((_) => this.loading = false)
                .finally((_) => this.loading = false)
        },
        getUploader(uploaderId) {
            if(this.getUser && this.getUser.id === uploaderId)
                return this.getUser.name
            return null
        }
    },

    computed: {
        ...mapGetters('user', [
            'getUser'
        ]),
        problemList() {
            return this.event.problem.filter((flag) => this.question.id == flag.question_id && (flag.hasOwnProperty('modified_by') || flag.hasOwnProperty('resolved_by')))
        }
    },

    components: {
        LoadingButton
    }
}
</script>

<style lang="scss">
.flag-record {
    width: calc(100% - 100px);
    display: flex;
    align-items: center;
    height: 35px;
    background-color: #f8f8f8;
    padding-left: 15px;
    margin-top: -16px;
    margin-right: 100px;
    margin-bottom: 10px;
    .flag-list {
        .flag-button {
            img {
                vertical-align: bottom;
            }
            font-size: 10px;
            background-color: #ffebeb;
            color: #da4e4e;
            padding: 3px 8px;
            border: 1px solid #da4e4e;
            margin-right: 12px;
            &.resolved {
                background-color: #e7ffea;
                color: #44b358;
                border: 1px solid #44b358;
            }
        }
    }
}
.flag-content {
    word-break: break-word;
    .comment {
        font-size: 14px;
        line-height: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 8px;
    }
    .comment-detail {
        font-size: 12px;
        color: #828282;
        line-height: 16px;
        display: block;
        margin-bottom: 12px;
    }
    .resolve-button {
        border-color: #709F34;
        background-color: #709F34;
        font-size: 12px;
        line-height: 14px;
        color: #ffffff;
        border-radius: 14px;
        padding: 6px 12px;
        &.is-disabled {
            background-color: #709F34;
        }
        &.resolved {
            background-color: #ffffff;
            color: #44B358;
            font-weight: 700;
            border: 1px solid #44B358;
            cursor: auto;
            img {
                vertical-align: sub;
            }
        }
    }
    .resolve-button:hover {
        background-color: #709F34;
    }
    .resolve-button.resolved:hover {
        background-color: #ffffff;
    }
    .resolved-status {
        display: flex;
        .resolve-datetime {
            font-size: 10px;
            line-height: 12px;
            color: #709F34;
            margin-left: 10px;
        }
    }
}
</style>